module.exports = __webpack_public_path__ + "static/media/RightBuActive.6e3f735f.svg";